export default __webpack_public_path__ + "static/media/icon-filetype-jpg.e9788cd5.svg";